export default __webpack_public_path__ + "static/IBMPlexSans-SemiBold-Latin1-7d46ea83f372f13d40a0be0f3efe9ddc.woff";